// Status das cobranças (códigos do Asaas, gravados pelo back / webhook).
export const STATUS_PAGOS = ['RECEIVED', 'CONFIRMED', 'RECEIVED_IN_CASH'];

export const STATUS_COBRANCA = {
    RECEIVED: { label: 'Pago', tone: 'success' },
    CONFIRMED: { label: 'Pago', tone: 'success' },
    RECEIVED_IN_CASH: { label: 'Pago em dinheiro', tone: 'success' },
    PENDING: { label: 'Pendente', tone: 'warning' },
    OVERDUE: { label: 'Vencido', tone: 'error' },
    REFUNDED: { label: 'Estornado', tone: 'neutral' },
    DELETED: { label: 'Removido', tone: 'neutral' },
};

export const statusCobranca = (status) =>
    STATUS_COBRANCA[String(status || '').toUpperCase()] || { label: status || '—', tone: 'neutral' };

export const METODOS_PAGAMENTO = {
    BOLETO: 'Boleto',
    PIX: 'Pix',
    CREDIT_CARD: 'Cartão de crédito',
    DEBIT_CARD: 'Cartão de débito',
    UNDEFINED: 'A definir',
};

export const metodoPagamento = (metodo) => METODOS_PAGAMENTO[String(metodo || '').toUpperCase()] || metodo || '—';
